import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuiasList } from "./multiselectorguias";

export interface Props extends kea.ModalProps<number[], boolean, number[]> {
}

/**
* Modal de edición para un ClienteDescripcionPaquete
*/
export class CargaZEGuiasEdit extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    items = observeResource(resources.Guia.QueryGuiasZonaExtendida);

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onChange = async (x: number[]) => {
        this.props.onChange(x);
    }

    render() {
        const value = this.props.value;
        const idGuiasYaIncluidas = this.props.params;
        const getField = this.getField;
        const items = this.items;

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Incluir guías"
            >
                <kea.Title titulo={"Seleccionar guías"} >
                </kea.Title>
                <MultiselectorGuiasList value={value} idGuiasYaIncluidas={idGuiasYaIncluidas} onChange={this.onChange} items={items} hideBusqueda />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/multiselector/edit.tsx